import { ILevel, Level } from "models";

export enum GameStatus {
  RESET,
  COUNTDOWN,
  PLAYING,
  SUCCESS,
  FAIL,
}

export interface GameState {
  chosenLevel: Level;
  rotations: { turns: number; canRotate: boolean }[];
  status: GameStatus;
  isTimerFrozen: boolean;
  freezeTimePowerUsed: boolean;
  fixTilePowerUsed: boolean;
  remainingTime: number;
  totalMoves: number;
}

export interface SetChosenLevelAction {
  payload: ILevel;
}

export interface SetGameStatusAction {
  payload: GameStatus;
}

export interface SetRotationsAction {
  payload: { turns: number; canRotate: boolean }[];
}

export interface FixTileAction {
  payload: { turns: number; tileIndex: number };
}

export interface SetIsTimerFrozenAction {
  payload: boolean;
}

export interface SetFreezeTimePowerUsedAction {
  payload: boolean;
}

export interface SetFixTilePowerUsedAction {
  payload: boolean;
}

export interface SetRemainingTimeAction {
  payload: number;
}

export interface RotateTileAction {
  payload: number;
}
